// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';
$w.onReady(function () {

if(wixWindow.formFactor === "Mobile"){

$w("#column5").show();
$w("#column6").show();
$w("#column7").show();

$w("#columnStrip6").hide();

}
else{
	$w("#columnStrip6").show()
}

});